/* eslint-disable i18next/no-literal-string */
import React from 'react';
import footerImg from 'assets/images/general-landing/footer.png';
import { ReactComponent as Arrow } from 'assets/images/general-landing/arrow.svg';
import styles from './Footer.module.scss';

export default function Footer() {
  return (
    <div className={styles.container}>
      <img src={footerImg} alt="footer" className={styles.footerImg} />
      <div className={styles.info}>
        <div className={styles.col1}>
          <div className={styles.title}>
            Let's talk
          </div>
          <div className={styles.phone}>
            (+84) 34 6140 991
          </div>
          <div className={styles.other}>
            <table>
              <tbody>
                <tr>
                  <td className={styles.label}>
                    [Mail]
                  </td>
                  <td className={styles.value}>
                    <a href="mailto:support@auto-design.io">
                      support@auto-design.io
                    </a>
                  </td>
                </tr>
                <tr>
                  <td className={styles.label}>
                    [Address]
                  </td>
                  <td className={styles.value}>
                    57, Ly Than Tong street, Vo Cuong ward, Bac Ninh province, Vietnam
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className={styles.separator} />
        <div className={styles.col23Container}>
          <div className={styles.col2}>
            <div className={styles.title}>
              Find out more at
            </div>
            <div className={styles.navs}>
              <a href="">
                {' '}
                <Arrow />
                About us
              </a>
              <a href="">
                {' '}
                <Arrow />
                Our services
              </a>
              <a href="">
                {' '}
                <Arrow />
                DIY staging platform
              </a>
              <a href="">
                {' '}
                <Arrow />
                Our blog
              </a>
            </div>
          </div>

          <div className={styles.separator} />
          <div className={styles.col3}>
            <div className={styles.title}>
              Pricings
            </div>
            <div className={styles.navs}>
              <a href="">
                <Arrow />
                Virtual staging & renovation
              </a>
              <a href="">
                {' '}
                <Arrow />
                Video & photo editing
              </a>
              <a href="">
                {' '}
                <Arrow />
                3D & 2D floor plan
              </a>
              <a href="">
                {' '}
                <Arrow />
                3D rendering & modeling
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.last}>
        <div className={styles.copyright}>
          © Copyright 2025, Betates - Virtual Staging Company
        </div>
        <div className={styles.links}>
          <a href="">Privacy policy</a>
          <a href="">Terms of service</a>
        </div>
      </div>
    </div>
  );
}
